import * as ACTION_TYPES from "../actions/action-types";

const initialState = {
  details: {},
  userProjects: [],
  visitingByAdmin: false,
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const userDetails = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.SET_USER_DETAILS:
      return {
        ...state,
        details: payload,
      };
    case ACTION_TYPES.SET_USER_PROJECTS:
      return {
        ...state,
        userProjects: payload,
      };
    case ACTION_TYPES.SET_VISITING_BY_ADMIN:
      return {
        ...state,
        visitingByAdmin: payload,
      };
    case ACTION_TYPES.SET_ALL_USER_DETAILS:
      return {
        ...state,
        details: payload?.details,
        userProjects: payload?.userProjects,
        visitingByAdmin: payload?.visitingByAdmin,
      };
    default:
      return state;
  }
};

export default userDetails;
